import { React, useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { useLazyQuery, useMutation } from '@apollo/client';
import axios from 'axios';

import { ADD_IMAGE, SET_IMAGE_UPLOADED } from "../../utils/mutations";
import { idbPromise } from "../../utils/helpers";

import Form from 'react-bootstrap/Form';
import Toast from 'react-bootstrap/Toast';
import Button from 'react-bootstrap/Button';

import './ImageUpload.css';

function ImageUpload({initialImageId, onSuccess, onError, small}) {

  const [edited, setEdited] = useState(false);
  const [imageId, setImageId] = useState(initialImageId);
  const fileInputRef = useRef();

  const [addImage, { data, loading, error }] = useMutation(ADD_IMAGE);
  const [setImageUploaded, { data: imageUploadedData, loading: imageUploadedLoading, error: imageUploadedError }] =
    useMutation(SET_IMAGE_UPLOADED);

  function upload(e) {
    const file = fileInputRef.current.files[0];

    addImage({
        variables: {
          filename: file.name,
          mimeType: file.type
        }
      })
      .then(({data}) => {
        console.info(`Image ${file.name} created in database`)
        return axios.put(data.addImage.signedUploadUrl, file, {headers: {'Content-Type': file.type}})
          .then (() => {
              console.info('image uploaded to S3')
              return setImageUploaded({ variables: {_id: data.addImage._id} })
            })
          .then(() => {
              console.info('image upload complete')
              if(onSuccess) {
                setImageId(data.addImage._id);
                onSuccess(data.addImage._id);
              }
            });
      })

      .catch(e => {
        console.error(e)
        if(onError) {
          onError(e)
        }
      });
  }

  return (
    <Form.Group className="mb-3">
      <div className={`image-container ${small ? 'small' : ''}`}>
        {imageId ? <img src={`/image/${imageId}`} alt=" " /> : 'No image set'}
      </div>

      <Form.Control ref={fileInputRef} type="file" name="image" accept="image/*"
        onChange={e => setEdited(true)} className="my-2" />

      <Button type="button" variant="primary" className="btn-sm me-3" disabled={! edited}
        onClick={e => upload(e)}>Upload Image</Button>

      <Button type="button" variant="secondary" className="btn-sm" disabled={! imageId}
        onClick={e => { setImageId(null); onSuccess(null) }}>Remove Image</Button>
    </Form.Group>
  );
}

export default ImageUpload;

